import baseapi from "./../baseAPI";
import {successMesg, errorMesg, infoMessage, warningMesg} from "./../../Pages/Toaster";

export const LeadDataAPI = async (setLeads, setLoading, setShowLeads, currentPage, perpagedata, setPageCount, setStages, setPrograms, setInstitutes, filterparams=null, setTotalRecords, setSources) =>
{
    setLoading(true);

    let searchparam = "";

    if(filterparams != "" && filterparams != null && filterparams != undefined)
    {
        searchparam = `?${filterparams.toString()}`;
    }
    else
    {
        searchparam = "?page=" + currentPage + "&per_page=" + perpagedata;
    }

    try
    {
        const response = await baseapi.get("/api/caller/leads" + searchparam);
        
        //console.log("Data got successfully", response.data.data.data);
        //let userdata = ['ram', 'shyam', 'rohit'];
        setLeads(response.data.data.data);
        setStages(response.data.stage);
        setPrograms(response.data.programs);
        setInstitutes(response.data.institutes);
        setTotalRecords(response.data.data.total);
        setSources(response.data.sourcelist);
        setLoading(false);
        setShowLeads(false);

        

        if(response.data.data.total > 0)
        {
            //console.log('Total count====='+response.data.data.total);
            let pagecount = Math.ceil(response.data.data.total / perpagedata);

            console.log('page count====' + pagecount);

            setPageCount(pagecount);
        }
        else
        {
            setPageCount(0);
        }

    }
    catch(error)
    {
        console.error("Error in user list:", error);
        setLoading(false);
    };
}

export const getStages = async (setStageList) =>
{
    //setLoading(true);

    try
    {
        const response = await baseapi.get("/api/caller/stages");

        //console.log("Data got successfully", response);
        //let userdata = ['ram', 'shyam', 'rohit'];
        setStageList(response.data.datalist);
        //setLoading(false);
    }
    catch(error)
    {
        console.error("Error in user list:", error);
        //setLoading(false);
    };
}

export const getDispositionAPI = async (dispositionid, setDispositions) =>
{
    //setLoading(true);

    try
    {
        const response = await baseapi.get("/api/caller/disposition/" + dispositionid);

        //console.log("Data got successfully", response);
        //let userdata = ['ram', 'shyam', 'rohit'];
        setDispositions(response.data.datalist);
        //setLoading(false);
    }
    catch(error)
    {
        console.error("Error in user list:", error);
        //setLoading(false);
    };
}

export const getSubDispositionAPI = async (dispositionid, setSubDispositions) =>
{
    //setLoading(true);

    try
    {
        const response = await baseapi.get("/api/caller/sub-disposition/" + dispositionid);

        //console.log("Data got successfully", response);
        //let userdata = ['ram', 'shyam', 'rohit'];
        setSubDispositions(response.data.datalist);
        //setLoading(false);
    }
    catch(error)
    {
        console.error("Error in user list:", error);
        //setLoading(false);
    };
}

export const editLeadAPI = async (leadid, setTxtName, setTxtEmail, setTxtContact, setTxtOtherContact, setTxtLocation, setTxtDisposition, setTxtSubDisposition, setScheduleDate, setScheduleTime, setTxtRemarks, setLoading, setRemarks) =>
{
    setLoading(true);

    try
    {
        const response = await baseapi.get("/api/caller/lead/edit/" + leadid);

        //console.log("Data got successfully", response.data);
        
        setTxtName(response.data.data.name);
        setTxtEmail(response.data.data.email);
        setTxtContact(response.data.data.contact);
        setTxtLocation(response.data.data.location);

        if(response.data.data.leadinfodata !==  null)
        {
            setTxtOtherContact(response.data.data.leadinfodata.alternate_contact);        
            setTxtDisposition(response.data.data.leadinfodata.disposition_id);
            setTxtSubDisposition(response.data.data.leadinfodata.subdisposition_id);
            setTxtRemarks(response.data.data.data.source);
        }

        if(response.data.data.notificationdata !== null)
        {
            setScheduleDate(response.data.data.notificationdata.display_date);
            setScheduleTime(response.data.data.notificationdata.display_time);
        }

        setRemarks(response.data.remarktext);
            
        setLoading(false);
    }
    catch(error) 
    {
        console.error("Error in user list:", error);
        setLoading(false);
    };
}

export const updateLeadDataAPI = async (params, setBtnLoading, navigate) =>
{
    setBtnLoading(true);

    try
    {
        const response = await baseapi.post("/api/caller/lead/update", params);

        //console.log("Data got successfully", response);
        
        if(response.data.code == 200)
        {
            successMesg("Lead has been updated successfully");

            navigate('/caller/leads');
        }
        else
        {
            errorMesg("Lead has not been updated. Please try again!!!");
        }
        
        setBtnLoading(false);
    }
    catch(error)
    {
        console.error("Error in user list:", error);
        setBtnLoading(false);
        errorMesg("Lead has not been updated. Please try again!!!");
    };
}

export const LeadFilterDataAPI = async (setLeads, setLoading, currentPage, perpagedata, setPageCount, filtertype, setPrograms, setInstitutes, setTotalRecords, filterparamsdata) =>
{
    setLoading(true);

    let searchparam = "";

    if(filterparamsdata != "" && filterparamsdata != null && filterparamsdata != undefined)
    {
        searchparam = `?${filterparamsdata.toString()}`;
    }
    else
    {
        searchparam = "?page=" + currentPage + "&per_page=" + perpagedata;
    }

    try
    {
        //const response = await baseapi.get("/api/caller/lead/filter/" + filtertype + "?page=" + currentPage + "&per_page=" + perpagedata);
        const response = await baseapi.get("/api/caller/lead/filter/" + filtertype + searchparam);
        
        //console.log("Data got successfully", response.data.data.data);
        //let userdata = ['ram', 'shyam', 'rohit'];
        setLeads(response.data.leadlist.data);
        //setDispositions(response.data.disposition);
        setLoading(false);
        //setShowLeads(false);

        setPrograms(response.data.programs);
        setInstitutes(response.data.institutes);

        

        if(response.data.leadlist.data.length > 0)
        {
            console.log('Total count====='+response.data.leadcount);
            let pagecount = Math.ceil(response.data.leadcount / perpagedata);

            //console.log('page count====' + pagecount);

            setTotalRecords(response.data.leadcount);

            setPageCount(pagecount);
        }

    }
    catch(error)
    {
        console.error("Error in user list:", error);
        setLoading(false);
    };
}

export const getStagesAPI = async (setStages, setLoading) =>
{
    //setLoading(true);

    try
    {
        const response = await baseapi.get("/api/caller/stages");

        //console.log("Data got successfully", response);
        //let userdata = ['ram', 'shyam', 'rohit'];
        setStages(response.data.datalist);
        //setLoading(false);
    }
    catch(error)
    {
        console.error("Error in user list:", error);
        //setLoading(false);
    };
}

export const getProfileInfoAPI = async (setBasicInfo, setOtherInfo, setRemarks, setPipeline, setTxtPipeline, leadid, setPageLoader, setBtnRefreshLoader) =>
{
    //setPageLoader(true);

    try 
    {
        //const response = await baseapi.get('api/caller/lead/profile/' + leadid);

        const[basicdata, otherdata, remarklist, stagedata] = await Promise.all([
                                                                baseapi.get('api/caller/lead/' + leadid + '/basic-info'),
                                                                baseapi.get('api/caller/lead/' + leadid + '/other-info'),
                                                                baseapi.get('api/caller/lead/' + leadid + '/remarks'),
                                                                baseapi.get('api/caller/lead/' + leadid + '/stages'),
                                                            ]);

        //console.log("Data got successfully", response.data.data);
        //let userdata = ['ram', 'shyam', 'rohit'];
        //setCampaignList(response.data.data.data);
        //setLoading(false);
        
        setBasicInfo(basicdata.data.datalist);
        setOtherInfo(otherdata.data.datalist);
        //setNotifications(notifylist.data.datalist);
        setRemarks(remarklist.data.datalist);
        setPageLoader(false);

        if(stagedata.data.datalist !== "" && stagedata.data.datalist !== null && stagedata.data.datalist !== undefined)
        {
            if(stagedata.data.datalist.length > 0)
            {
                setPipeline(stagedata.data.datalist);
            }
            else
            {
                setTxtPipeline(stagedata.data.laststage);
            }
        }

        setBtnRefreshLoader(false);

    } 
    catch (error) 
    {
        console.error("Error in user list:", error);
        setPageLoader(false);
    }

}

export const getBasicProfileAPI = async (setName, setEmail, setContact, setLocation, setProgram, setInstitute, profileid) =>
{
    //setLoading(true);

    try 
    {
        const response = await baseapi.get('api/caller/lead/' + profileid + '/basic-info');

        //console.log("Data got successfully", response.data.data);

        setName(response.data.datalist.name);
        setEmail(response.data.datalist.email);
        setContact(response.data.datalist.contact);
        setLocation(response.data.datalist.location);
        setProgram(response.data.datalist.program);
        setInstitute(response.data.datalist.institute);

    } 
    catch (error) 
    {
        console.error("Error in user list:", error);
        //setLoading(false);
    }

}

export const getOtherProfileAPI = async (setOtherEmail, setOtherContact, setDesignation, profileid) =>
{
    //setLoading(true);

    try 
    {
        const response = await baseapi.get('api/caller/lead/' + profileid + '/other-info');

        //console.log("Data got successfully", response.data.datalist);
        //let userdata = ['ram', 'shyam', 'rohit'];
        setOtherEmail(response.data.datalist.other_email);
        setOtherContact(response.data.datalist.alternate_contact);
        setDesignation(response.data.datalist.designation);
        //setLoading(false);

    } 
    catch (error) 
    {
        console.error("Error in user list:", error);
        //setLoading(false);
    }

}

export const getRemarksAPI = async (setRemarksList, leadid) =>
{
    //setLoading(true);

    try 
    {
        const response = await baseapi.get('api/caller/lead/' + leadid + '/remarks')

        //console.log("Data got successfully", response.data);
        //let userdata = ['ram', 'shyam', 'rohit'];
        setRemarksList(response.data.datalist);
        //setIsRemarksReload(false);

    } 
    catch (error) 
    {
        console.error("Error in user list:", error);
        //setLoading(false);
    }

}

export const getStagePipelineAPI = async (setPipeline, setTxtPipeline, setIsPipelineReload, leadid) =>
{
    //setLoading(true);

    try 
    {
        const response = await baseapi.get('api/caller/lead/' + leadid + '/stages');



        if(response.data.datalist !== "" && response.data.datalist !== null && response.data.datalist !== undefined)
        {
            if(response.data.datalist.length > 0)
            {
                setPipeline(response.data.datalist);
            }
            else
            {
                setTxtPipeline(response.data.laststage);
            }
        }

        setIsPipelineReload(false);
    } 
    catch (error) 
    {
        console.error("Error in user list:", error);
        //setLoading(false);
    }

}

export const UpdateBasicInfoAPI = async (formData, setBtnSubmitSpin, setIsUpdateBasicInfo, setIsBasicInfoModal, onReload) =>
{
    setBtnSubmitSpin(true);

    try
    {
        const response = await baseapi.post("/api/caller/lead/update-basic-info", formData);

        //console.log("Data got successfully", response);
        
        if(response.data.code === 200)
        {
            successMesg("Basic information has been updated successfully");

            setIsUpdateBasicInfo(true);

            setIsBasicInfoModal(false);

            onReload();
        }
        else
        {
            errorMesg("Basic information has not been updated. Please try again!!!");

            setIsBasicInfoModal(false);
        }
        
        setBtnSubmitSpin(false);
    }
    catch(error)
    {
        console.error("Error in user list:", error);
        setBtnSubmitSpin(false);
        errorMesg("Basic information has not been updated. Please try again!!!");
    };
}

export const UpdateOtherInfoAPI = async (formData, setBtnSubmitSpin, setIsUpdateOtherInfo, setIsOtherInfoModal, onReload) =>
{
    setBtnSubmitSpin(true);

    try
    {
        const response = await baseapi.post("/api/caller/lead/update-other-info", formData);

        //console.log("Data got successfully", response);
        
        if(response.data.code === 200)
        {
            successMesg("Other information has been updated successfully");

            setIsUpdateOtherInfo(true);

            setIsOtherInfoModal(false);

            onReload();
        }
        else
        {
            errorMesg("Other information has not been updated. Please try again!!!");

            setIsOtherInfoModal(false);
        }
        
        setBtnSubmitSpin(false);
    }
    catch(error)
    {
        console.error("Error in user list:", error);
        setBtnSubmitSpin(false);
        setIsOtherInfoModal(false);
        errorMesg("Other information has not been updated. Please try again!!!");
    };
}

export const AddRemarksAPI = async (formdata, setBtnRSubmitSpin, setIsRemarksAddModal, setIsRemarksReload, resetRemarksForm, onReload) =>
{
    setBtnRSubmitSpin(true);

    try
    {
        const response = await baseapi.post("/api/caller/lead/remarks-add", formdata);

        //console.log("Data got successfully", response);
        
        if(response.data.code === 200)
        {
            successMesg("Remarks has been added successfully");

            setIsRemarksReload(true);

            setIsRemarksAddModal(false);

            resetRemarksForm();

            onReload();
        }
        else
        {
            errorMesg("Remarks has not been added. Please try again!!!");

            setIsRemarksAddModal(false);
        }
        
        setBtnRSubmitSpin(false);
    }
    catch(error)
    {
        console.error("Error in user list:", error);
        setBtnRSubmitSpin(false);
        setIsRemarksAddModal(false);
        errorMesg("Remarks has not been added. Please try again!!!");
    };
}

export const saveNewLeadDataAPI = async (params, setLoading, resetUserForm) =>
{
    setLoading(true);

    try 
    {
        const response = await baseapi.post('api/caller/lead/add', params);

        //console.log("Data got successfully", response);
        
        if(response.data.code === 200)
        {
            successMesg("Lead has been added successfully");

            resetUserForm();
        }
        else
        {
            errorMesg("Lead has not been added. Please try again!!!");
        }
        
        setLoading(false);

    } 
    catch (error) 
    {
        console.error("Error in user list:", error);
        setLoading(false);
        errorMesg("Lead has not been added. Please try again!!!");
    }
}

export const globalSearchAPI = async (formData, navigate) =>
{
    //setLoading(true);

    try
    {
        const response = await baseapi.post('api/caller/global-search', formData);

        //console.log("Data got successfully", response);

        if(response.data.code === 200)
        {
            navigate('/caller/lead-profile/' + response.data.leadid);

        }
        else
        {
            errorMesg(response.data.mesg);
        }

    }
    catch (error)
    {
        console.error("Error in user list:", error);

        errorMesg(error);
    }
}

export const getFollowupNotifications = async () =>
{
    //setLoading(true);

    try
    {
        const response = await baseapi.get('api/caller/followup-alert')

        return response.data.alertlist;

    }
    catch (error)
    {
        //console.error("Error in user list:", error);
        //setLoading(false);
        console.error("Error in user list:", error);
        return [];
    }

}

export const alertMarkAsReadAPI = async (id) =>{

    try
    {
        const params = { notificationid: id };
        const response = await baseapi.post('api/caller/followup-alert-update', params)

        //return response.data.alertlist;
        if(response)
        {

        }

    }
    catch (error)
    {
        //console.error("Error in user list:", error);
        //setLoading(false);
        console.error("Error in user list:", error);
        return [];
    }

}
